import styled from 'styled-components';

export const ProfessorsItemWrapper = styled.div`
  border-radius: 5px;
  min-height: 350px;
  ${props => props.theme.breakpoints.up('sm')} {
    min-height: 400px;
  }
  ${props => props.theme.breakpoints.up('md')} {
    min-height: 500px;
  }
  ${props => props.theme.breakpoints.up('lg')} {
    min-height: 460px;
  }
`;

export const ProfessorItemImage = styled.div`
  border-radius: 5px;
`;
